import { render, staticRenderFns } from "./CategoriesNav.vue?vue&type=template&id=44e99c79&scoped=true"
import script from "./CategoriesNav.vue?vue&type=script&lang=js"
export * from "./CategoriesNav.vue?vue&type=script&lang=js"
import style0 from "./CategoriesNav.vue?vue&type=style&index=0&id=44e99c79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e99c79",
  null
  
)

export default component.exports